<template>
  <div class="ns">
    <div class="ns-inner">
      <!--新闻tab-->
      <NewsTab />
      <!-- 新闻轮播图-->
      <!-- <Carousel /> -->

      <!--入驻商户、实验室、发布需求-->
      <Settled />
    </div>
  </div>
</template>
<script>
import NewsTab from "./NewsTab";
import Settled from "./Settled";
// import Carousel from "./Carousel";
// import Scroll from "./Scroll";
// import SettledScroll from "./SettledScroll.vue";
import { demandList } from "@/api/hall";
import { mapGetters } from "vuex";
export default {
  components: {
    NewsTab,
    // Scroll,
    Settled,
    // Carousel,
    // SettledScroll,
  },
  data() {
    return {
      page: {
        pageIndex: 1,
        pageSize: 9,
      },
      demands: [],
      ents: [], // 企业列表
      labs: [], // 实验室列表
    };
  },
  computed: {
    ...mapGetters(["token", "userBaseInfo"]),
  },
  created() {
    // 获取需求
    this.getDemandList();
  },
  methods: {
    // 发布检测需求
    releaseReq() {
      if (this.token) {
        this.$jump.push({ name: "releaseReq" });
      } else {
        this.$store.dispatch("login");
      }
    },
    // 获取需求
    async getDemandList() {
      const { list } = await this.$axios.post(demandList, this.page);
      this.demands = list.map((item) => {
        return {
          title: item.demandProjectName,
          date: item.createTime,
          id: item.demandId,
        };
      });
    },
    toDemandDetail(id) {
      this.$jump.push({
        name: "demandDetail",
        query: {
          id,
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/style/variable";
.ns {
  padding-top: 30px;
  padding-bottom: 20px;
  background: url($oss-url + "home/bg/bg-3.png") no-repeat center center / cover;
  &-inner {
    width: $max-width;
    margin: 0 auto;
    // display: grid;
    // grid-template-columns: repeat(2, calc(50% - 10px));
    // gap: 20px;
  }
}
</style>
